import CryptoJS from 'crypto-js';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { BrightnessService } from 'src/app/services/brightness.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationService } from 'src/app/services/notification.service';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ActionSheetController, AlertController, NavController, Platform } from '@ionic/angular';
import { BusesGps, Ticket } from '@shared/models/tickets.model';

const IAB_OPTIONS: InAppBrowserOptions = {
  location: 'no',
  hidenavigationbuttons: 'yes',
  toolbarposition: 'bottom',
  toolbarcolor: '#0e53a1',
  navigationbuttoncolor: '#ffffff',
  hideurlbar: 'yes',
  closebuttoncaption: 'Cerrar',
};

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.page.html',
  styleUrls: ['./ticket.page.scss'],
})
export class TicketPage implements OnInit {
  user;
  ticket;
  subscription;
  qr: string;
  private secureKey = '17749937251153819552391078335260'; // Any string, the length should be 32
  showQr = false;
  qrSize = 300;

  constructor(
    private route: ActivatedRoute,
    private brightnessService: BrightnessService,
    private platform: Platform,
    private apiService: ApiService,
    private authService: AuthService,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private iab: InAppBrowser,
    private actionSheetController: ActionSheetController
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data['special']) {
      const ticket = this.route.snapshot.data['special'];
      if (ticket.method && ticket.method !== 'subscription') {
        this.ticket = ticket;
        this.getTicket();
      } else {
        this.ticket = ticket;
        this.showQr = true;
        console.log('It is suscription ticket: ', ticket);
      }
    } else {
      this.getTicket();
    }

    this.authService.getUser().then((user) => {
      this.user = user;
      this.updateQr();
    });

    this.qrSize = Math.min(window.innerWidth - 40, 350);
  }

  async cancelTicket() {
    const alert = await this.alertCtrl.create({
      header: 'Cancelar boleto',
      message: '¿Está seguro que desea cancelar el boleto?',
      buttons: [
        {
          text: 'No, regresar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          },
        },
        {
          text: 'Sí, cancelar',
          handler: () => {
            this.loadingService.present();
            this.apiService
              .putData('bustickets/' + this.ticket.id, {})
              .then(() => {
                this.notificationService.showAlert('Notificación', 'Ticket cancelado con éxito.');
                this.navCtrl.navigateRoot(['/tecservice-transportec/tickets']);
              })
              .finally(() => {
                this.loadingService.dismiss();
              })
              .catch((error) => {
                this.notificationService.showAlert('Error', 'Favor de intentar nuevamente.');
                console.log('Error en cancelar ticket: ' + error);
              });
          },
        },
      ],
    });

    await alert.present();
  }

  updateQr() {
    if (this.user && this.ticket) {
      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
      const n = new Date(Date.now() - tzoffset).toISOString().slice(0, 19).replace('T', ' ');
      // this.qr = window.btoa("expresotec|"+this.user.id+"|"+this.n+"|");
      if (this.ticket.method && this.ticket.method !== 'subscription') {
        this.qr = CryptoJS.AES.encrypt(
          'transportec-t|' + this.user.id + '|' + this.ticket.id + '|' + n + '|',
          this.secureKey
        ).toString();
      } else {
        this.qr = CryptoJS.AES.encrypt(
          'transportec-s|' + this.user.id + '|' + this.ticket.id + '|' + n + '|',
          this.secureKey
        ).toString();
      }
    }
  }

  ionViewDidEnter() {
    if (this.platform.is('cordova')) {
      this.brightnessService.setBrightness();
    }
  }

  ionViewWillLeave() {
    if (this.platform.is('cordova')) {
      this.brightnessService.resetBrightness();
    }
  }

  getTicket() {
    this.apiService
      .getData('bustickets/' + this.route.snapshot.paramMap.get('id'))
      .then((res) => {
        console.log('ticket: ', res);
        if (res.data) {
          this.ticket = res.data;
          // this.showQrWhenHasNotStarted();
          this.showQr = true;
          this.updateQr();
        } else {
          console.log('Error: ', res);
        }
      })
      .finally(() => {});
  }

  onTrack(ticket: Ticket): void {
    if (!ticket.buses_gps?.length) {
      return;
    }

    if (ticket.buses_gps?.length === 1) {
      this.iab.create(ticket.buses_gps[0].url_gps, '_blank', IAB_OPTIONS);
      return;
    }

    if (ticket.buses_gps?.length > 1) {
      this.presentTrackOptionsAlert(ticket.buses_gps);
    }
  }

  async presentTrackOptionsAlert(options: BusesGps[]) {
    const buttons = options.map((option) => {
      return {
        text: option.name,
        handler: () => {
          this.iab.create(option.url_gps, '_blank', IAB_OPTIONS);
        },
      };
    });
    const actionSheet = await this.actionSheetController.create({
      header: 'Autobuses',
      buttons,
    });
    await actionSheet.present();
  }

  /**
   * Show QR when ticket has not started (starts_at is in the future with 2 hours of tolerance)
   */
  private showQrWhenHasNotStarted(): void {
    if (this.ticket.starts_at) {
      const startsAt = new Date(this.ticket.starts_at).getTime();
      const now = Date.now();
      if (startsAt + 7200000 > now) {
        this.showQr = true;
      }
    }
  }
}
